import dayjs from 'dayjs'

/**
 * 计算 Roas 日期选择器在「显示不完整数据 / 完整数据截止日」下的下一状态。
 * 供 RoasDatePickerTroasGate 与 MyDatePicker 的 defaultAllowIncomplete 分支共用，避免规则漂移。
 *
 * @param {Record<string, unknown>} prev - zustand 当前切片（须含 endDate、allowIncomplete）
 * @param {{ defaultAllowIncomplete: boolean; completeDateStr: string }} options
 *   completeDateStr 为 YYYYMMDD，与 getLastCompleteDate(true) / roas-complete 一致
 * @returns {Record<string, unknown>} 合并后的状态（浅拷贝 prev 再改 allowIncomplete/endDate）
 */
export function computeRoasDatePickerDefaultState(prev, {
  defaultAllowIncomplete,
  completeDateStr,
}) {
  const next = { ...prev, allowIncomplete: defaultAllowIncomplete }
  const maxCompleteDate = dayjs(completeDateStr, 'YYYYMMDD')
  if (defaultAllowIncomplete) {
    if (prev.endDate === completeDateStr) {
      next.endDate = dayjs().format('YYYYMMDD')
    }
  } else if (dayjs(prev.endDate, 'YYYYMMDD').isAfter(maxCompleteDate.endOf('day'))) {
    next.endDate = completeDateStr
  }
  return next
}
